import classNames from 'classnames'

import { PaymentPreference } from 'src/routes/(registry)/api/types'
import { RegItemMinimalCardDetailsProps } from '../RegItemMinimalCardDetails.types'
import css from '../RegItemMinimalCardDetails.styles.scss'

const CashFundDetails: React.FC<RegItemMinimalCardDetailsProps> = ({
  registry,
  regItem,
}: RegItemMinimalCardDetailsProps) => {
  const { title } = regItem
  const wrapperClasses = classNames(
    css.RegItemMinimalCardDetails,
    css.CashFundDetails
  )

  let paymentOptions = []

  if (registry?.cashFundPreferences) {
    paymentOptions = registry?.cashFundPreferences?.paymentPreferences
      ?.filter(
        (paymentPreference: PaymentPreference) => paymentPreference.selected
      )
      .map((paymentPreference: PaymentPreference) => paymentPreference.name)
  }

  return (
    <div className={wrapperClasses} data-testid="CashFundDetails">
      <div className={css.Title}>{title}</div>
      <div className={css.Price}>Any amount</div>
      {paymentOptions.length > 0 && (
        <div className={css.PaymentOptions}>{paymentOptions.join(', ')}</div>
      )}
    </div>
  )
}

export default CashFundDetails
